import SectionLabel from './SectionLabel'
import { WA_NUMBER, WA_MESSAGES } from '../constants'

export default function ProcessSteps() {
  const steps = [
    { n: '01', title: 'Share your plans', text: 'Message me your rough dates, trek interest, and group size.' },
    { n: '02', title: 'Build the itinerary', text: 'We shape the route, package, and dates together — no pressure.' },
    { n: '03', title: 'Book with a deposit', text: 'Secure your spot directly. No agency, no hidden fees.' },
    { n: '04', title: 'Trek, worry-free', text: 'Permits, guide, and support handled. You just show up and walk.' },
  ]

  return (
    <section className="section bg-stone">
      <div className="process-grid" style={{ display: 'grid', gridTemplateColumns: '280px minmax(0,1fr)', gap: '48px' }}>
        <div>
          <SectionLabel>How It Works</SectionLabel>
          <h2 className="section-title">Your trip, in four steps.</h2>
          <a
            href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES.plan)}`}
            target="_blank" rel="noreferrer"
            className="btn btn-green"
          >
            Start Planning
          </a>
        </div>

        <div className="process-steps" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px' }}>
          {steps.map(s => (
            <div key={s.n}>
              <div style={{ fontFamily: 'var(--serif)', fontSize: '36px', fontWeight: 600, color: 'var(--green-mid)', opacity: 0.5, marginBottom: '8px' }}>
                {s.n}
              </div>
              <h3 style={{ fontSize: '15px', fontWeight: 600, marginBottom: '8px' }}>{s.title}</h3>
              <p style={{ fontSize: '13px', color: 'var(--ink-mid)', lineHeight: 1.6, fontWeight: 300 }}>{s.text}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .process-grid { grid-template-columns: 1fr !important; }
          .process-steps { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 560px) {
          .process-steps { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  )
}
